package com.zq.my_official_website

import androidx.compose.foundation.border
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.viewinterop.WebElementView
import kotlinx.browser.document
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLIFrameElement

/**
 * 使用 [WebElementView] 把 iframe 挂进 Compose 的 HTML 互操作层（叠在 Skiko canvas 之上）。
 * 若仅 append 到 document.body，图层会在 canvas 下方，小地图永远不可见。
 */
@OptIn(ExperimentalComposeUiApi::class)
@Composable
actual fun AboutPageBaiduMiniMap(address: String, modifier: Modifier) {
    WebElementView(
        factory = {
            val root = document.createElement("div") as HTMLElement
            root.style.setProperty("width", "100%")
            root.style.setProperty("height", "100%")
            root.style.setProperty("background-color", "#F7F8FB")
            root.style.setProperty("overflow", "hidden")

            val iframe = document.createElement("iframe") as HTMLIFrameElement
            iframe.setAttribute("title", "公司位置地图预览")
            iframe.setAttribute("loading", "lazy")
            iframe.setAttribute("referrerpolicy", "no-referrer-when-downgrade")
            iframe.style.setProperty("width", "100%")
            iframe.style.setProperty("height", "100%")
            iframe.style.setProperty("border", "0")
            iframe.style.setProperty("display", "block")

            root.appendChild(iframe)
            root
        },
        modifier = modifier
            .clip(RoundedCornerShape(8.dp))
            .border(1.dp, Color(0xFFE7E9EE), RoundedCornerShape(8.dp)),
        update = { root ->
            val iframe = root.firstChild as? HTMLIFrameElement ?: return@WebElementView
            val q = percentEncodeQueryComponent(address)
            val src = "/map.html?embed=1&address=$q"
            if (iframe.getAttribute("data-map-src") != src) {
                iframe.setAttribute("data-map-src", src)
                iframe.src = src
            }
        },
    )
}
